module.exports = __webpack_public_path__ + "img/7_Stem_cell_reports_cover.5f39fee8.jpg";